export default __webpack_public_path__ + "static/MediaContentFourFancybox-0f4a5271238a3b922ec6de956f842a73.webp";